import FinishProposal from './FinishProposal';

export default FinishProposal;
